// 'use client';

// Third-party Imports
import classnames from 'classnames';

// Hook Imports
import useVerticalNav from '../../../@menu/hooks/useVerticalNav';

// Util Imports
import { verticalLayoutClasses } from '../../../@layouts/utils/layoutClasses';

export const VerticalFooterContent = () => {
  // Hooks
  const { isBreakpointReached } = useVerticalNav();

  return (
    <div
      className={classnames(verticalLayoutClasses.footerContent, 'flex items-center justify-between flex-wrap gap-4')}
    >
      <p>
        <span>{`© ${new Date().getFullYear()}, Made with `}</span>
        <span>❤️</span>
        <span>{` by `}</span>
        <a href="https://themeselection.com" target="_blank" className="text-primary" rel="noreferrer">
          ThemeSelection
        </a>
      </p>
      {!isBreakpointReached && (
        <div className="flex items-center gap-4">
          <a href="https://themeselection.com/license" target="_blank" className="text-primary" rel="noreferrer">
            License
          </a>
          <a href="https://themeselection.com" target="_blank" className="text-primary" rel="noreferrer">
            More Themes
          </a>
          <a
            href="https://demos.themeselection.com/materio-mui-nextjs-admin-template/documentation"
            target="_blank"
            className="text-primary"
            rel="noreferrer"
          >
            Documentation
          </a>
          <a href="https://themeselection.com/support" target="_blank" className="text-primary" rel="noreferrer">
            Support
          </a>
        </div>
      )}
    </div>
  );
};
